(() => {
  function enhance(root) {
    if (root.dataset.trackingEnhanced) return;
    root.dataset.trackingEnhanced = 'true';
    const contact = root.querySelector('.th-track-contact');
    if (contact?.querySelector('[role="status"],[role="alert"]')) contact.open = true;
    // App labels are divs: supply accessible names without replacing its inputs.
    const labelInputs = () => root.querySelectorAll('.track123-input-content').forEach(wrapper => {
      const input = wrapper.querySelector('input');
      const label = wrapper.querySelector('.track123-input-label');
      if (input && label && !input.hasAttribute('aria-label')) input.setAttribute('aria-label', label.textContent.trim());
    });
    labelInputs();
    const widget = root.querySelector('.th-track-widget');
    if (widget) {
      const observer = new MutationObserver(labelInputs);
      observer.observe(widget, {childList:true,subtree:true});
      document.addEventListener('shopify:section:unload', event => {
        if (event.target.contains(root)) observer.disconnect();
      }, {once:true});
    }
  }
  document.querySelectorAll('.th-track').forEach(enhance);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.th-track').forEach(enhance));
})();
